import React from 'react';
import classnames from 'classnames';
import kebabCase from 'lodash/kebabCase';
import { useSelector } from 'react-redux';
import { noop } from 'lodash';

import { selectStyleSelectorShown } from '../../../../common/store/ui';
import Field, {
  FIELD_TYPES,
} from '../../../../common/components/forms/field/Field';
import WizardLayout from '../../../../common/components/wizard-layout/WizardLayout';
import Responsive, {
  useMobile,
} from '../../../../common/components/responsive/Responsive';

export interface RoadItemEditProps {
  item;
}

const RoadItemEdit = ({ item }: RoadItemEditProps) => {
  const isMobile = useMobile();
  const styleSelectorShown = useSelector(selectStyleSelectorShown);
  if (isMobile && styleSelectorShown) {
    return null;
  }

  return (
    <WizardLayout
      className={classnames('item-edit', '')}
      title={'Edit Road'}
      hasTitleBackButton={false}
      hasOuterBackButton={true}
      hasCloseButton={false}
      fullScreen={false}
      description={'Roads update'}
    >
      <Responsive mobile={false}>
        <form className={classnames('form', 'edit-road')} onSubmit={noop}>
          <div className="form__fields-container">
            <Field
              key={'name'}
              className={`form__field form__field-${kebabCase('name')}`}
              field={'name'}
              type={FIELD_TYPES.input}
              label={'name'}
              required={false}
              value={item.properties['name']}
              onChange={noop}
            />
            <Field
              key={'class'}
              className={`form__field form__field-${kebabCase('class')}`}
              field={'class'}
              type={FIELD_TYPES.input}
              label={'class'}
              required={false}
              value={item.properties['class']}
              onChange={noop}
            />
            <Field
              key={'type'}
              className={`form__field form__field-${kebabCase('type')}`}
              field={'type'}
              type={FIELD_TYPES.input}
              label={'type'}
              required={false}
              value={item.properties['type']}
              onChange={noop}
            />
            <Field
              key={'oneway'}
              className={`form__field form__field-${kebabCase('oneway')}`}
              field={'oneway'}
              type={FIELD_TYPES.input}
              label={'oneway'}
              required={false}
              value={item.properties['oneway']}
              onChange={noop}
            />
            <Field
              key={'structure'}
              className={`form__field form__field-${kebabCase('structure')}`}
              field={'structure'}
              type={FIELD_TYPES.input}
              label={'structure'}
              required={false}
              value={item.properties['structure']}
              onChange={noop}
            />
            <Field
              key={'layer'}
              className={`form__field form__field-${kebabCase('layer')}`}
              field={'layer'}
              type={FIELD_TYPES.input}
              label={'layer'}
              required={false}
              value={item.properties['layer']}
              onChange={noop}
            />
            {Object.keys(item.properties)
              .filter(
                (k) =>
                  ![
                    'sourceLayerFeatureId',
                    'name',
                    'class',
                    'type',
                    'structure',
                    'oneway',
                    'layer',
                  ].includes(k),
              )
              .map((field) => (
                <Field
                  key={field}
                  className={`form__field form__field-${kebabCase(field)}`}
                  field={field}
                  type={FIELD_TYPES.input}
                  label={field}
                  required={false}
                  value={item.properties[field]}
                  onChange={noop}
                />
              ))}
          </div>
        </form>
      </Responsive>
    </WizardLayout>
  );
};

export default RoadItemEdit;
